import { MAIN_CATEGORY } from './categories';

export const CONFIG = {
    ENABLE_CONSENTS_IN_LOGIN_FLOW: 'enableConsentsInLoginFlow',
    COMMUNICATION_PREFERENCES: 'communicationPreferences',
    SHOW_MODERN_DESIGN: 'showModernDesign',
    SHOW_PRIVACY_URL: 'showPrivacyUrl',
    HOST: 'host',
    SITE_CODE: 'siteCode',
    OLX_AUTOS: 'olxAutos',
    OLX_AUTOS_CAR_CATEGORY: 'carCategory',
    STATIC_ASSETS: 'staticAssets',
    DEFAULT_CITY: 'defaultCity',
    ENABLE_DEFAULT_COUNTRY: 'enableDefaultCountry',
    MARKET_CONFIG: 'marketConfig',
    ENABLE_COUNTRY_IN_AUTOCOMPLETE: 'enableCountryInAutocomplete',
    START_SELLING_BANNER_REDIRECTION_OLX_AUTOS: 'startSellingBannerRedirectOlxAutos',
    BLANK: '_blank',
    AUTOS_BANNER_IMAGE: 'autos-banner-image',
    NEW_CAR_REGULATION: 'newCarRegulation',
    ENABLED: 'enabled',
    CATEGORY_ID: 'categoryId',
    CARS_CATEGORY_BANNERS: 'carsCategoryBanners',
    CUSTOMER_CARE_BANNERS: 'customerCareBanners',
    CATEGORIES_IDS: 'categoryIds',
    AUTOS_BANNER: 'autosBanner',
    IS_ENABLED: 'isEnabled',
    AUTOS_OPERATIONAL_LOCATION: 'autosOperationalLocations',
    SHOWMODERDESIGN: 'showModernDesign',
    HOME: 'home',
    CARS_PLACEHOLDER: 'CarsPlaceholder',
    BANNER_URL: 'banners/car_category_olxautos_banner_',
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
    TAB: 'tab',
    THEME: 'theme',
    ID: 'id',
    SEO: 'SEO',
    LISTING_FAQ: 'listingFaq',
    CATEGORY_IDS: 'categoryIds',
    PACKAGES: 'packages',
    SHEET_HEIGHT: '450px',
    FEATURED_1: 'featured_1',
    FEATURED_2: 'featured_2',
    THUNDER: 'thunder',
    BOOST: 'boost',
    SELL_BANNER: 'sell_banner',
    BOOST_1: 'boost_1',
    BOOST_2: 'boost_2',
    PRODUCT_TYPE: 'product_type',
    EXAMPLE_PROPOSITION: 'exampleProposition_',
    ALL_CAR_CATEGORIES: 'allCarCategories',
    CROSS: 'cross',
    BRAND: 'brand',
    MONETIZER: 'monetizer',
    INFOBOX: 'infoBox'
};

export const SEARCH_ANIMATION_FALLBACK_TAGS = [
    'Cars',
    'Properties',
    'Mobiles',
    'Bikes',
    'Jobs'
];

export const SEARCH_ANIMATION_TIME = 1300;
export const RESET_ANIMATION_TIME = 50;
export const NUDGE_TITLES = {
    [MAIN_CATEGORY.JOBS]: 'openAppNudgeTitleJobs',
    'default': 'openAppNudgeTitle'
};
